module.exports = __webpack_public_path__ + "01ea978f/img/dollar-icon.35c9d638.svg";